// todo: funkce parseOrderInLetterData je v systému 2x, 1x v backendu a 1x ve frontendu
// todo: problém je s adresou eshopu, resp. v .env souborech, ve kterých je nastavení adresy shopu je definice rozdílná
export const parseLetterData = (order: GQL.IOrder, message: string | undefined) => {

  const tempCodes = {
    // identifikace objednávky
    orderId: order.id,
    orderNumber: order.orderNumber,
    shippingPackageNumber: order.shippingPackageNumber,
    shippingTrackingLink: order.shippingTrackingLink,
    // data zákaznáka
    email: order.email,
    phone: order.phone,
    // doručovací adresa
    street: order.deliveryStreet,
    houseNumber: order.deliveryHouseNumber,
    addressLine1: order.deliveryAddressLine1,
    addressLine2: order.deliveryAddressLine2,
    city: order.deliveryCity,
    zip: order.deliveryZip,
    countyState: order.deliveryCountyState,
    country: order.deliveryCountry,
    // celková cena objednávky
    total: order.total,
    paymentTotal: order.paymentTotal,
    deliveryTotal: order.deliveryTotal,
    orderTotal: order.grandTotal,
    // odkaz na detail objednávky v eshopu
    linkOrderDetail: `${process.env.REACT_APP_ESHOP_URL}/${order.country ? order.country.code : `cz`}/order-finished/${order.orderNumber}/${order.id}`,
  }

  let tempMessage = message || '';
  Object.keys(tempCodes).map((code: string) => {
    tempMessage = tempMessage.split(`{${code}}`).join(tempCodes[code] || '');
  });

  return tempMessage;
};



// WEBPACK FOOTER //
// ./src/helpers/parseLetterData.ts